<template>
	<form-page
		class="create-container"
		:title="$route.meta.header"
		routeBack="/router-list"
	>
		<!-- <div class="main-section">
			<h3>{{`${routerInfo.name || 'New'} Router`}}</h3>

			<form @submit.prevent="$emit('submit')">
				<div class="router-info">
					<InputField
						class="input-box"
						:limit="50"
						label="Router Name"
						placeholder="Enter Router Name"
						v-model="formData.name"
					/>

					<InputField
						class="input-box"
						:limit="50"
						label="Router MAC Address"
						placeholder="CC:1B:E0:E0:E9:10"
						v-model="formData.macAddress"
					/>
					
					<InputField
						class="input-box"
						:limit="50"
						label="Router IP Address"
						placeholder="IP Address"
						v-model="formData.ipAddress"
					/>

					<SelectField
						class="select-box"
						label="Country"
						placeholder="Country"
						displayProp="name"
						valueProp="name"
						idProp="name"
						:disabled="countryLoading"
						:items="countryList"
						v-model="formData.country"
						@input="getCountryList($event)"
					/>

					<SelectField
						class="select-box"
						label="Owner"
						placeholder="Select Owner"
						displayProp="company_name"
						valueProp="company_name"
						idProp="company_name"
						:disabled="countryLoading"
						:items="clientList"
						v-model="formData.owner"
						@input="getCountryList($event)"
					/>

				</div>

				<div
					class="band-container"
					v-for="(item, index) in formData.bands"
					:key="index"
				>
					<InputField
						class="input-box"
						:limit="50"
						:label="'Band Name'"
						:placeholder="'Enter Band Name'"
						v-model="formData.bands[index].name"
					/>

					<InputField
						class="input-box"
						:limit="50"
						label="Band MAC Address"
						placeholder="CC:1B:E0:E0:E9:10"
						v-model="formData.bands[index].macAddress"
					/>

					<span
						class="remove"
						@click="$emit('removeBand', {item, index})"
					>
						&times;
					</span>
				</div>

				<a
					v-if="formData.bands.length < 20"
					@click="formData.bands.push({ name: '', macAddress: '' })"
				>
					+ Add Band
				</a>

				<footer>
					<button
						class="_system-primary"
						:disabled="loading"
						type="submit"
					>
						Save
					</button>
				</footer>
			</form>
		</div> -->
		<div class="router-details" slot="nav">
			<nav>
				<ul>
					<li
						v-for="(item, index) in tabs"
						:key="index"
						@click="changeTab(index)"
						:class="{ 'active': activeTab === index }"
					>
						{{ item }}
					</li>
				</ul>
			</nav>

		</div>
		<div slot="content">
			<router-info @save="$emit('submit')" @remove-band="removeBand" class="active-tab-content" v-if="activeTab === 0"></router-info>
			<router-band-list class="active-tab-content" v-if="activeTab === 1"></router-band-list>
			<router-summary @update-band-details="changeRegisterTab(0)" @update-account-info="changeRegisterTab(1)" v-if="activeTab === 2"></router-summary>
		</div>

	</form-page>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import RouterInfo from './RouterInfo.vue'
// import RouterBands from './RouterBands.vue'
import RouterBandList from './RouterBandList.vue'
import RouterSummary from './RouterSummary.vue'
import FormPage from '@/components/layouts/FormPage.vue'

export default {
	props: ['id'],

	data () {
		return {
			tabs: ['Register', 'Registered Band', 'Summary']
		}
	},

	methods: {
		changeRegisterTab (index) {
			this.activeTab = 0
			this.registerTab = index
		},

		removeBand ({ item, index }) {
			const { bands } = this.formData
			if (item.id) this.deletedIds.push(item.id)
			if (bands.length === 1) {
				bands[0].name = ''
				bands[0].macAddress = ''
			} else {
				this.formData.bands.splice(index, 1)
			}
		},

		changeTab (index) {
			const { bands } = this.formData
			if (index === 1 && bands.length &&
				(bands[0].name.trim() !== '' ||
				bands[0].macAddress.trim() !== '')) {

				for (const [index, band] of bands.entries()) {
					const hasDuplicate = bands.some((_band, _index) => {
						return _band.macAddress === band.macAddress &&
								_index !== index
					})

					if (hasDuplicate) {
						this.throwWarning('MAC Address already exists.')
						return
					}
				}
			}

			if (this.scanning) {
				this.throwWarning('Please wait for the band scanning to stop.')
				return
			}

			this.activeTab = index
		},

		throwWarning (message) {
			this.$store.commit('modal/toggleNotification', {
				notificationName: 'notification-banner',
				notificationType: 'warning',
				notificationDesc: message
			})
		}
	},

	computed: {
		...mapFields('router', {
			loading: 'buttonLoading',
			formData: 'createForm',
			activeTab: 'activeTab',
			registerTab: 'registerTab',
			deletedIds: 'deletedIds',
			scanning: 'scanning'
		}),

		// saveBtnStr () {
		// 	return this.activeTab === 3 ? 'Save' : 'Next'
		// }
	},

	components: {
		RouterInfo,
		// RouterBands,
		RouterBandList,
		RouterSummary,
		FormPage
	}
}
</script>

<style lang="scss" scope>
.create-container {

	.router-details {
		width: 100%;
		border-radius: 5px;

		button {
			min-width: 80px;
		}

		nav {
			width: 100%;
			background-color: #F5F6FA;
			border-bottom: 1px solid #ddd;

			ul {
				display: flex;
				list-style: none;

				li {
					text-align: left;
					padding: 10px 0;
					border-bottom: 1px solid transparent;
					margin-right: 20px;
					cursor: pointer;
					color: #cccccc;

					&.active {
						border-color: #2DC4B6;
						color: #2DC4B6;
					}
				}
			}
		}

		.active-tab-content {
			border-radius: 5px;
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 100%;

			form {
				flex: 1 1 auto;
			}

			form > * {
				margin-bottom: 15px;
			}

		}
	}

	footer {
		margin-top: 30px;
		width: 100%;
		display: flex;
		justify-content: flex-end;
	}
}
</style>
